export default __webpack_public_path__ + "static/media/Group 569.85a00d20.png";